export enum requiredHeaders {
  UNIT_NUMBER = 'UNIT NUMBER',
  LESSON_NUMBER = 'LESSON NUMBER',
  ADDRESSING_STANDARDS = 'ADDRESSING STANDARDS',
}

export type requiredHeadersIndices = {
  [key in keyof typeof requiredHeaders]: number
}

export type unitsToLessonsToStandards = {
  [unitNumber: string]: {
    [lessonNumber: string]: string[]
  }
}
